import(/* webpackMode: "eager", webpackExports: ["RegisterComponent"] */ "/vercel/path0/components/auth/register_component.tsx");
